module.exports = __webpack_public_path__ + "static/media/sidebar-cross-button.0cfbeb57.svg";